/*
 * @Author: Wang hui
 * @Date: 2021-04-30 13:08:08
 * @LastEditTime: 2021-05-07 10:01:37
 * @LastEditors: Please set LastEditors
 * @Description: store分模块管理
 * @FilePath: \Wjb-Website\src\store\index.js
 */
import Vue from 'vue'
import Vuex from 'vuex'

import common from './modules/common';

Vue.use(Vuex)

let store = new Vuex.Store({
    modules: {
        common,
    }
});

export default store;